import Joi from 'joi';
import linkSchema from '@utils/validate/blocksSchemes/linkSchema';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const socialMediaSchema = Joi.object({
  type: Joi.string().valid('socialMedia').required(),
  code: Joi.string().allow('', null).required(),
  header: Joi.string().allow('', null).required(),
  headerColor: Joi.string().allow('', null).required(),
  items: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    link: linkSchema.required(),
    image: Joi.alternatives().try(Joi.string(), Joi.object(imageWithMetaDataSchema)).allow(null),
    blur: Joi.string().allow('', null).required(),
    text: Joi.string().allow('', null).required(),
    textColor: Joi.string().allow('', null).required(),
    icon: Joi.string().allow('', null).required(),
    iconColor: Joi.string().allow('', null).required()
  }).unknown(true))
}).unknown(true);
export default socialMediaSchema;